import React from 'react';
import { Title } from './styles';

const EmailSendSuccess = () => {
  return (
    <>
      <Title>The content of your basket has been sent!</Title>
    </>
  );
};

export default EmailSendSuccess;
